import React, { useState } from "react";
import AddButton from "./AddButton";
import {Button,Dialog,DialogActions,DialogContent,DialogTitle, IconButton} from "@mui/material";
import useDBO from "../hooks/useDBO";
import Lang from "./Lang";
import Loading from "../Loading";
import mut from "../hooks/mut";
import "./bookList.css"

import IconButtonHT from "./IconButtonHT";
import Search from "./Search";
import VND from "./VND";
import Text from "./Text";



export default function BookList({syllabus,setSyllabus}) {

  const [open,setOpen] = useState(false)

    return (
      <div>
        <div style={{ border: "1px solid #ccc", borderRadius: 5, padding: 5 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#ccc",
              borderRadius: 5,
              paddingLeft: 10,
              paddingRight: 10,
            }}
          >
            <div><Lang w="books"/></div>
            <div>
              <AddButton action={() => setOpen(true)} />
            </div>
          </div>
          <div style={{padding: 10}}>
            {syllabus.books.map((book) => (
              <DrawBook
                book={book}
                key={book._id}
                syllabus={syllabus}
                setSyllabus={setSyllabus}
              />
            ))}
          </div>
        </div>
        <BookChoice
          open={open}
          setOpen={setOpen}
          syllabus={syllabus}
          setSyllabus={setSyllabus}
        />
      </div>
    );
}

function DrawBook({ book, syllabus, setSyllabus }) {
  console.log(book)
    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {book.link ? (
          <a href={book.link} target="_blank">{book.name}</a>
        ) : (
          <div>{book.name}</div>
        )}
     
        <div>
          <IconButtonHT
            icon="cancel"
            style={{ color: "red" }}
            action={() => {
              setSyllabus({
                ...syllabus,
                books: syllabus.books.filter((b) => b._id !== book._id),
              });
              mut("post", `/update-syllabus/${syllabus._id}`, {
                books: syllabus.books
                  .filter((b) => b._id !== book._id)
                  .map((b) => b._id),
              });
            }}
          />
        </div>
      </div>
    );
}





function BookChoice(props) {
  const { open, setOpen, syllabus, setSyllabus } = props;
  const [newBook, setNewBook] = useState(false)
  const [newBookDetails, setNewBookDetails] = useState({name:"",link:"",sellPrice:""})
  const bookIds = syllabus.books.map(b => b._id)
    const books = useDBO(`/books`)
    const [search,setSearch] = React.useState("")
  if (books.loading) return <Loading />
  
  if(newBook) return (
    <Dialog
      open={open}
      fullWidth
    >
      <DialogTitle>New Book</DialogTitle>
      <DialogContent style={{display:"flex",flexDirection:"column", gap:5}}>
        <Text
          value={newBookDetails.name}
          setValue={(name) => setNewBookDetails((prev) => ({ ...prev, name }))}
          label={<Lang w="name" />}
      
        />
        <Text
          value={newBookDetails.link}
          setValue={(link) => setNewBookDetails((prev) => ({ ...prev, link }))}
          label={<Lang w="link" />}
        />
        <VND
          value={newBookDetails.sellPrice}
          setValue={(sellPrice) =>
            setNewBookDetails((prev) => ({ ...prev, sellPrice }))
          }
          label={<Lang w="price" />}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          onClick={() => {
            setOpen(false)
            setTimeout(() => {
                setNewBook(false);
            },500)
          
          }
          }
        >
          Close
        </Button>
        <Button
          color="success"
          disabled={!newBookDetails.name || !newBookDetails.link}
          onClick={async () => {
            let result = await mut("put", "/books", newBookDetails)
       
             setSyllabus({ ...syllabus, books: [...syllabus.books, result] });
             const bks = syllabus.books.map((b) => b._id);
             bks.push(result._id);
             mut("post", `/update-syllabus/${syllabus._id}`, { books: bks });
            setOpen(false)
             setTimeout(() => {
               setNewBook(false);
             }, 500);
            setNewBookDetails({ name: "", link: "", sellPrice: "" });
          }}
        >Go</Button>
      </DialogActions>
    </Dialog>
  );
  

  return (
    <Dialog
      open={open}
      fullWidth
    >
      <DialogTitle>
        <div style={{display:"flex", justifyContent:"space-between"}}>
          <Lang w="addANewBook" />
          <AddButton action={()=>setNewBook(true)} />
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ marginBottom: 10 }}>
          <Search
            search={search}
            setSearch={setSearch}
            fullWidth
          />
        </div>

        {books
          .sortBy("name")
          .filter(
            (b) =>
              !bookIds.includes(b._id) &&
              b.name.toUpperCase().includes(search.toUpperCase())
          )
          .map((b) => (
            <div
              className="book-in-list"
              onClick={() => {
                setSyllabus({ ...syllabus, books: [...syllabus.books, b] });
                setOpen(false);
                const bks = syllabus.books.map((b) => b._id);
                bks.push(b._id);
                mut("post", `/update-syllabus/${syllabus._id}`, { books: bks });
              }}
            >
              {b.name}
            </div>
          ))}
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          onClick={() => setOpen(false)}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}